export interface ResaleItemImage {
  signed_id: string;
  url: string;
  filename: string;
}

export interface ResaleItem {
  id: number;
  name: string;
  vendor: string | null;
  recommended_retail_price: number | null;
  cost_to_company: number | null;
  item_notes: string | null;
  delivery_information?: string | null;
  max_quantity?: number | null;
  images?: ResaleItemImage[];
  created_at?: string;
  active: boolean;
}

export type ResaleItemStatus = 'active' | 'inactive';

export const RESALE_ITEM_STATUS_VALUES = ['active', 'inactive'] as const;

export interface ResaleItemTab {
  key: ResaleItemStatus;
  label: string;
}

export interface ResaleItemsTabsProps {
  currentStatus: ResaleItemStatus;
  onStatusChange: (status: ResaleItemStatus) => void;
  disabled?: boolean;
  layoutId?: string;
  className?: string;
}

export interface ResaleItemsTableProps {
  resaleItems: ResaleItem[];
  currentStatus: ResaleItemStatus;
  onStatusToggle: (id: number, active: boolean) => void;
  onItemClick?: (id: number) => void;
  isLoading?: boolean;
  isFetching?: boolean;
  isError?: boolean;
  onRetry?: () => void;
  /** RBAC: when false, omit the row actions column (edit / activate / deactivate). */
  canWrite?: boolean;
  className?: string;
}

export interface AllResaleItemsPageProps {
  currentStatus: ResaleItemStatus;
  totalCount: number;
  onStatusChange: (status: ResaleItemStatus) => void;
  onCreateNewClick: () => void;
  onStatusToggle: (id: number, active: boolean) => void;
  resaleItems: ResaleItem[];
  isLoading?: boolean;
  isFetching?: boolean;
  isError?: boolean;
  onRetry?: () => void;
  selectedResaleItemId?: number | null;
  onSelectedResaleItemChange?: (id: number | null) => void;
  /** RBAC: when false, hide write affordances (New button, row actions, edit/status). */
  canWrite?: boolean;
}
